import PropTypes from "prop-types";
import ActivityItem from "@/pages/user_management/components/single_user/Activity_Item";

const ActivityTimeline = ({ avatar, activities }) => {
  return (
    <div className="mt-8">
      <h1 className="heading-medium text-left mb-4">My Activities</h1>
      {!activities || activities.length === 0 ? (
        <p className="text-left text-darkGrey">No activities</p>
      ) : (
        <div className="relative">
          {/* Vertical Timeline Line */}
          <div className="absolute left-[50px] top-10 bottom-10 w-[2px] bg-[#EAECF0]" />

          <div className="space-y-12">
            {activities.map((activity) => (
              <ActivityItem
                key={activity.id}
                avatar={avatar}
                activity={activity}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

ActivityTimeline.propTypes = {
  avatar: PropTypes.string,
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      time: PropTypes.string,
      task: PropTypes.string,
      status: PropTypes.string,
      assignedBy: PropTypes.string,
      assignedByImage: PropTypes.string,
    })
  ),
};

export default ActivityTimeline;
